import React from 'react';

// Redux
import { useSelector, useDispatch } from 'react-redux';

// Material
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Radio from '@material-ui/core/Radio';

// Constants
import CONST_COLLECTION from 'constants/collection';

// Actions
import { setSelectedCollection } from 'store/ducks/employees/actions';

// Types
import { ApplicationState } from 'store';

// Styles
import useStyles from './collectionFilter.styles';

const CollectionFilter: React.FC = () => {
  const classes = useStyles();

  const dispatch = useDispatch();

  const selectedCollection = useSelector(
    (state: ApplicationState) => state.employees.selectedCollection,
  );

  const handleCollection = (collection: number) => {
    dispatch(
      setSelectedCollection({
        selectedCollection: collection,
      }),
    );
  };

  const handleCleanSelection = () => {
    if (selectedCollection !== null) {
      dispatch(
        setSelectedCollection({
          selectedCollection: null,
        }),
      );
    }
  };

  return (
    <Box marginTop={1}>
      <List dense>
        {CONST_COLLECTION.TYPE.map(({ KEY, VALUE }) => (
          <ListItem key={KEY} button>
            <ListItemText
              primary={VALUE}
              onClick={() => {
                handleCollection(KEY);
              }}
              classes={{ root: classes.itemText }}
            />
            <ListItemSecondaryAction>
              <Radio
                edge='end'
                color='primary'
                onChange={() => handleCollection(KEY)}
                checked={selectedCollection === KEY}
                inputProps={{ 'aria-labelledby': VALUE }}
              />
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
      <Box marginTop={2}>
        <Grid container justifyContent='flex-end' alignItems='center'>
          <Button
            variant='outlined'
            color='primary'
            onClick={handleCleanSelection}>
            Limpar seleção
          </Button>
        </Grid>
      </Box>
    </Box>
  );
};

export { CollectionFilter };
export default CollectionFilter;
